riot.tag2('skipstats', '<table class="ui celled striped table"> <tbody> <tr if="{globalData}"> <td>Hörerverlust/Minute insgesamt:</td> <td><h4 class="ui center aligned header">{globalData.global_avg_hvpm}%</h4></td> </tr> <tr if="{globalData}"> <td><strong>Hörerverlust/Minute diese Stunde:</strong></td> <td><h4 class="ui center aligned header">{globalData.global_avg_hvpm_hour}%</h4></td> <tr if="{actualData}"> <td><div class="ui ribbon label">Aktueller Song</div> {actualData.song} {actualData.artist && ⁗von⁗} {actualData.artist} <span if="{actualData.linkdetails}">({actualData.gespielt}x gespielt, {actualData.sum_absprung} Absprünge bei {actualData.sum_hoerer} Hörern)</span> <a href="{actualData.linkdetails}" target="_blank" if="{actualData.linkdetails}">Detailansicht</a> </td> <td class="{actualData.hoererverlust_pro_min>globalData.global_avg_hvpm_hour ? ⁗negative⁗ :                         actualData.hoererverlust_pro_min<globalData.global_avg_hvpm_hour ? ⁗positive⁗: ⁗⁗}"><h4 class="ui center aligned header">{actualData.hoererverlust_pro_min ? actualData.hoererverlust_pro_min+⁗%⁗ : ⁗-⁗}</h4></td> </tr> <tr each="{lastPlayed}"> <td><button class="ui icon button right floated" onclick="{playSong}" if="{element_type===⁗music⁗}"><i class="play icon"></i></button>{new Date(played).toLocaleTimeString(⁗de-DE⁗)}: {song} {artist && ⁗von⁗} {artist} </td> <td class="{hoererverlust_pro_min>globalData.global_avg_hvpm_hour ? ⁗negative⁗ :                         hoererverlust_pro_min<globalData.global_avg_hvpm_hour ? ⁗positive⁗: ⁗⁗}"><h4 class="ui center aligned header">{hoererverlust_pro_min ? hoererverlust_pro_min+⁗%⁗ : ⁗-⁗}</h4></td> </tr> </tbody> </table>', '', 'if="{debug}"', function(opts) {
"use strict";

var _this = this;

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radio = opts.radio;
var channels = opts.channels;
var debugMsg = opts.debugMsg;
var debug = debug;
var globalData = null;
var actualData = null;
var lastPlayed = null;
var now = new Date();

this.debug = debug;

this.playSong = function (event) {
    var item = event.item;
    debugMsg(item.file);
    var pseudoChannel = {
        "skip": false,
        "streamurl": {
            "lq": item.file
        },
        "name": item.artist + " - " + item.song,
        "ondemand": true
    };
    radio.switch(pseudoChannel, "lq");
    radio.once("play", function (data) {
        item.meta = [];
        item.channel = item.channelkey;
        radio.emit("metadata", item);
        /*
        this.actualData = {}
        this.actualData.song = item.song
        this.actualData.artist = item.artist
        this.update()
        */
    });
};

radio.on("metadata", function (data) {
    debugMsg("[Event] meta - skipstatstag");
    _this.actualData = {};

    if (data.song) {
        _this.actualData.song = data.song;
        _this.actualData.artist = data.artist;
        _this.update();

        var suchstring = "";
        if (data.artist) {
            suchstring += data.artist;
        }
        if (data.song) {
            suchstring += " " + data.song;
        }
        _axios2.default.get("https://klassikradio.streamabc.com/content/get-rating/programme/" + data.channel + "/search/" + suchstring.replace(/[\-'"]/i, " ") + "/gespielt/1/to/" + now.toLocaleDateString('DE-de') + "/min_hoerer/1").then(function (response) {
            if (response.data.length > 0) {
                var playstats = response.data[0];
                var _now = new Date();
                _this.globalData = {};

                _this.globalData.global_avg_hvpm = Math.round(parseFloat(playstats.globals.global_avg_hvpm) * 100) / 100;
                _this.globalData.global_avg_hvpm_hour = Math.round(parseFloat(playstats.globals.global_avg_hvpm_hour[_now.getHours()]) * 100) / 100;

                _this.actualData.hoererverlust_pro_min = Math.round(parseFloat(playstats.hoererverlust_pro_min) * 100) / 100;
                _this.actualData.gespielt = playstats.gespielt;
                _this.actualData.sum_hoerer = playstats.sum_hoerer;
                _this.actualData.sum_absprung = playstats.sum_absprung;
                _this.actualData.linkdetails = "https://klassikradio.streamabc.com/cockpit/index/type/contentanalysedetail/code/" + response.data[0].code + "/to_ts/" + parseInt(_now.getTime() / 1000) + "/min_hoerer/1/";

                /*
                let statsHTML = `<strong>Hörerverlust pro Minute:</strong> ${Math.round(parseFloat(playstats.hoererverlust_pro_min)*100)/100}% <svg class="sparkline" width="150" height="30" stroke-width="3"></svg><br>`
                statsHTML += `${playstats.gespielt}x gespielt, ${playstats.sum_absprung} Absprünge bei ${playstats.sum_hoerer} Hörern. `
                statsHTML += `<a href="https://klassikradio.streamabc.com/cockpit/index/type/contentanalysedetail/code/${playstats.code}/to_ts/${Math.floor(Date.now()/1000)}/min_hoerer/1/" target="_blank">Detailansicht öffnen</a>`
                $("#Playing .stats").html(statsHTML)
                 let absprungData = JSON.parse(playstats.lastplayed[playstats.code][0].absprungverlauf_json)
                */
                _this.update();
            }
        }).catch(function (error) {
            debugMsg(error);
        });

        _axios2.default.get("https://api.streamabc.net/playliststats/lasttracks/" + data.channel + "?size=11&jwt=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1MTYwMDc5MzAsImV4cCI6MTU3OTA3OTkzMCwiYXVkIjoiaW50ZXJuYWwiLCJzdWIiOiJwbGF5b3V0ZXhwb3J0ZXIiLCJzYWJjIjoidHJ1ZSJ9.7tNnt2Vc-FT0E951qV1H8Zyir7yPOK8YeSxBLIaC6rY").then(function (response) {
            _this.lastPlayed = response.data;
            _this.lastPlayed.shift();

            var statsRequests = [];
            for (var i = 0; i < _this.lastPlayed.length; i++) {
                var _suchstring = "";
                if (_this.lastPlayed[i].artist) {
                    _suchstring += _this.lastPlayed[i].artist;
                }
                if (_this.lastPlayed[i].song) {
                    _suchstring += " " + _this.lastPlayed[i].song;
                }
                statsRequests.push(_axios2.default.get("https://klassikradio.streamabc.com/content/get-rating/programme/" + data.channel + "/search/" + _suchstring.replace(/[\-'"]/i, " ") + "/gespielt/1/to/" + now.toLocaleDateString('DE-de') + "/min_hoerer/10"));
            }
            _axios2.default.all(statsRequests).then(function (res) {
                for (var _i = 0; _i < res.length; _i++) {
                    if (res[_i].data.length > 0) {
                        var trackData = res[_i].data[0];
                        _this.lastPlayed[_i].hoererverlust_pro_min = Math.round(parseFloat(trackData.lastplayed[trackData.code][0].hoererverlust_pro_min) * 100) / 100;
                    }
                }
                _this.update();
            }).catch(function (error) {
                debugMsg(error);
            });
        }).catch(function (error) {
            debugMsg(error);
        });
    }
});
});



// WEBPACK FOOTER //
// ./src/js/elements/skipstats.tag